import gsx from 'styles'

const styles = {
  root: {
    overflowy: { sm: 'auto' },
    overflowx: 'hidden',
    height: { xs: 'auto', md: '700px' },
    '& ::-webkit-scrollbar, ::-webkit-scrollbar-thumb': {
      display: { xs: 'none' },
    },
  },

  btnsContainer: {
    marginTop: 4,
  },
  registerButton: {
    paddingY: 1.7,
    paddingX: 4,
    mb: 2,
  },

  loginButton: {
    '&.MuiButton-outlined': {
      border: '1px solid #122549!important',
      backgroundColor: 'white!important',
    },
    '&.MuiButton-outlined:hover': {
      backgroundColor: '#F1F1F1!important',
    },
  },
  loginButtonTimeline: {
    '&.MuiButton-outlined': {
      border: '1px solid #122549!important',
      backgroundColor: 'white!important',
    },
  },

  btnsTimelineContainer: {
    ml: { xs: 0, lg: 3 },
  },

  mainButtonTimeline: {
    paddingY: 1.5,
    paddingX: 4,
  },

  containerMobile: {
    backgroundColor: 'background.grey',
  },

  googleReviewsContainer: {
    '& > .MuiGrid-container': {
      ...gsx.googleReviewsContainer,
      marginTop: 3,
    },
  },

  '& iframe': {
    borderTopLeft: 2,
  },

  quoterFirstContainer: {
    paddingX: { xs: '0px!important', lg: 'unset' },
    '& .MuiGrid2-container': {
      padding: '0px!important',
    },
    '& .MuiAutocomplete-root': {
      marginBottom: (theme) => theme.spacing(2),
      '&:first-of-type': {
        marginRight: { lg: 1 },
      },
    },
    '& .MuiGrid2-root': {
      '&:last-of-type': {
        marginTop: 0,
        paddingTop: 0,
      },
    },
  },

  quoterContainer: {
    paddingX: { xs: '0px!important', lg: 'unset' },
    '& .MuiGrid2-container': {
      padding: '0px!important',
    },
    '& .MuiButton-root': {
      padding: '16px!important',
    },
  },

  firstQuoterContainer: {

  },

  ratingComponent: {
    '& .MuiGrid-container': {
      backgroundColor: 'transparent',
      paddingY: 3,
    },
  },

  internalContainer: {
    '&.MuiGrid2-container': {
      marginBottom: '0px!important',
    },
    '& .MuiPaper-root': {
      background: { md: 'white' },
      border: { md: '1px solid #F1F1F1' },
      borderRadius: '2px',
    },
  },

  mainContainer: {
    '&.Main-Banner-Container-root': {
      paddingBottom: 3,
    },
  },

  timelineContainer: {
    '& .Timeline-Container-root': {
      paddingY: { lg: 6 },
      paddingX: { lg: 10 },
    },
  },

  internalContainerEasy: {
    '& .MuiPaper-root': {
      borderRadius: '2px',
    },
  },

  linearGradient: {
    background: {
      lg: 'linear-gradient(to bottom, #fff 0%, #fff 25%, #f7f9fb 25%, #f7f9fb 80%, #fff  80%, #fff 100%)',
    },
  },

  login: {
    '& .MuiPaper-root': {
      borderRadius: 1,
    },

  },
}

export default styles
